import "./HomeAdditions2.module.css";
import Header from "@/reusable_sections/Header";
import HomeAdditionHeroAnswer from "./sections/HomeAdditionHeroAnswer";
import AdditionDecisions from "./sections/AdditionDecisions";
import AdditionTimelineAndTriggers from "./sections/AdditionTimelineAndTriggers";
import HomeAdditionProcess from "./sections/HomeAdditionProcess";
import HomeAdditionFaq from "./sections/HomeAdditionFaq";
import HomeAddition from "./sections/HomeAddition";
import EstimateForm from "./sections/EstimateForm";
import Footer from "@/reusable_sections/Footer";
export default function HomeAdditions2Page() {
  return <div>
      <Header />
      <HomeAdditionHeroAnswer />
      <AdditionDecisions />
      <AdditionTimelineAndTriggers />
      <HomeAdditionProcess />
      <HomeAdditionFaq />
      <EstimateForm />
      <HomeAddition />
      <Footer />
    </div>;
}